<template>
  <div class="vimeo-embed">
    <div class="embed-hold" @click="activate">
      <div class="video-placehold" :class="{ 'is-activated': activated }">
        <wpImage
          v-if="poster"
          :data="poster"
          size="large"
          class="poster-image"
          lazy
          background
          placeholder
        />
        <span class="play-badge" v-html="playIcon"></span>
      </div>
      <div class="embed" ref="video" v-html="html" />
    </div>
  </div>
</template>

<script>
import Player from "@vimeo/player";
import WpImage from "@/components/elements/WpImage";

export default {
  name: "vimeo-embed",
  components: {
    WpImage
  },
  props: {
    html: {
      type: String,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    poster: {
      type: [Object, Boolean],
      default: false
    }
  },
  data() {
    return {
      player: null,
      activated: false,
      playIcon:
        '<svg width="66" height="66" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="33" cy="33" r="33" fill="#FFF" opacity="0.9"/><path d="M27 21.5 47 33 27 44.5z" fill="#2A2E34"/></g></svg>'
    };
  },
  mounted() {
    if (this.autoplay) {
      this.activate();
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  },
  methods: {
    activate() {
      const VM = this;
      if (!VM.player) {
        VM.activated = true;
        const el = VM.$refs.video;
        if (!el) return;
        const iframe = el.querySelector("iframe");
        if (!iframe) return;
        VM.player = new Player(iframe);
      }
      VM.player.play();
    },
    pause() {
      if (this.player) this.player.pause();
    }
  }
};
</script>

<style lang="scss">
.vimeo-embed {
  .embed-hold {
    position: relative;
  }
  .video-placehold {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: transparent;
    cursor: pointer;
    &.is-activated {
      display: none;
    }
    .poster-image {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0;
      background-size: cover;
      background-position: center;
    }
    .play-badge {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 30; // WpImage's internal layers go up to 20
      transition: transform 0.12s ease-in-out;
      svg {
        display: block;
        width: 66px;
        height: 66px;
      }
    }
    &:hover .play-badge {
      transform: translate(-50%, -50%) scale(1.08);
    }
  }
  .embed {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    background-color: #d8d8d8;

    iframe {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
